export default "__VITE_ASSET__230777ff__"